export enum AuthenticationSourceType {
	System = 'System',
	LDAP = 'LDAP',
	Sso = 'Sso'
}
